import { render } from "./AuthorOverview.vue?vue&type=template&id=105a4260"
import script from "./AuthorOverview.vue?vue&type=script&lang=ts"
export * from "./AuthorOverview.vue?vue&type=script&lang=ts"

import "./AuthorOverview.vue?vue&type=style&index=0&id=105a4260&lang=scss"
script.render = render

export default script